<template>
  <section class="transfer-box">
    <section class="transfer-left">
      <TableBox
        ref="tableBoxLeft"
        :tableDataTitle="leftTableDataTitle"
        :tableDataSelectTar="tableDataSelectTar"
      />
    </section>
    <section class="transfer-center">
      <div class="transfer-btn add" @click="handleCheckAddData">加入</div>
      <div class="transfer-btn remove" @click="removeData">移除</div>
    </section>
    <section class="transfer-right">
      <TableBox
        ref="tableBoxRight"
        :tableDataTitle="rightTableDataTitle"
        :tableDataSelectTar="tableDataSelectTar"
        :showCtrlUpDownBtn="true"
      />
    </section>
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  props: {
    // 表格数据
    tableDataTitle: {
      type: Array,
      default: () => ([]),
    },
    // 左侧 table 表头数据
    leftTableDataTitle: {
      type: Array,
      default: () => ([]),
    },
    // 右侧 table 表头数据
    rightTableDataTitle: {
      type: Array,
      default: () => ([]),
    },
    // 判断是否选中的字段名
    tableDataSelectTar: {
      type: String,
      default: 'id',
    },
    // 手动检测添加数据
    isManualCheckAddData: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
    };
  },
  methods: {
    // 设置左侧 table 的数据
    setData (data) {
      const rightTableData = this.$refs.tableBoxRight.tableData.data;
      if (rightTableData && rightTableData.length) {
        // 如果将要设置的数据已经在右侧存在，则从将要设置的数据中移除掉
        const newTableData = data.filter((item) => !rightTableData.some((info) => item[this.tableDataSelectTar] === info[this.tableDataSelectTar]));
        this.$refs.tableBoxLeft.setTableData(newTableData);
      } else {
        // 如果右侧没有数据，直接展示全部将要设置的数据
        this.$refs.tableBoxLeft.setTableData(data);
      }
    },
    // 检测加入的数据
    handleCheckAddData () {
      const currentSelectedData = this.$refs.tableBoxLeft.getSelectedResult();
      if (currentSelectedData.length) {
        if (this.isManualCheckAddData) {
          const rightTableData = this.getRightTableBoxData();
          // 抛出去组件外手动检测
          this.$emit('checkAddData', currentSelectedData, rightTableData);
        } else {
          this.addData();
        }
      }
    },
    // 加入
    addData (data) {
      // 获取当前左侧选中的数据
      // const currentSelectedData = this.$refs.tableBoxLeft.getSelectedResult();
      // if (currentSelectedData.length) {
      const currentSelectedData = data || this.$refs.tableBoxLeft.getSelectedResult();
      // 将当前选中的数据从左侧移除
      this.$refs.tableBoxLeft.removeTableData(currentSelectedData);
      // 将当前选中的数据插入右侧
      this.$refs.tableBoxRight.insertTableData(currentSelectedData);
      // 清除左侧之前选中的数据记录
      this.$refs.tableBoxLeft.resetSelectedResult();
      // 抛出已在右侧的数据
      this.$emit('addData', this.getRightTableBoxData());
      // }
    },
    // 移除
    removeData () {
      // 获取当前右侧选中的数据
      const currentSelectedData = this.$refs.tableBoxRight.getSelectedResult();
      if (currentSelectedData.length) {
        // 将当前选中的数据从右侧移除
        this.$refs.tableBoxRight.removeTableData(currentSelectedData);
        // 将当前选中的数据插入左侧
        this.$refs.tableBoxLeft.insertTableData(currentSelectedData);
        // 清除右侧之前选中的数据记录
        this.$refs.tableBoxRight.resetSelectedResult();
      }
      this.$emit('removeData', this.getRightTableBoxData());
    },
    // 获取左侧 table 数据
    getLeftTableBoxData () {
      return this.$refs.tableBoxLeft.tableData.data;
    },
    // 获取右侧 table 数据
    getRightTableBoxData () {
      return this.$refs.tableBoxRight.tableData.data;
    },
    // 设置右侧 table 数据
    setRightTableBoxData (data) {
      this.$refs.tableBoxRight.tableData.data = data;
    },
    // 重置左侧 table 数据
    resetLeftTableBoxData () {
      this.$refs.tableBoxLeft.tableData.data = [];
    },
    // 重置右侧 table 数据
    resetRightTableBoxData () {
      this.$refs.tableBoxRight.tableData.data = [];
    },
  },
};
</script>

<style scoped lang="scss">
.transfer-box {
  display: flex;
  margin-bottom: 16px;
  .transfer-left,
  .transfer-right {
    width: calc(50% - 38px);
  }
  // .transfer-left {
  // }
  // .transfer-right {
  // }
  .transfer-center {
    width: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .transfer-btn {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      margin-top: 16px;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
      }
      &.add {
        border: 1px solid #0088ff;
        color: #0088ff;
        &:hover {
          background-color: #0088ff;
          color: #ffffff;
        }
      }
      &.remove {
        border: 1px solid #f5222d;
        color: #f5222d;
        &:hover {
          background-color: #f5222d;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
